export const licenseKey =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImY5ZDJiNWNlLWZlMTQtNGFkMC1iZjI4LWI1MjliZmFkOTNjZCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.VIbEJ3LBLBkEMbEMG80LZCo8+We4vxqiMoeJ+JuMoJ9kSyYh5YVga0kbxi10E5pwWhrHz7troxhTNAEWu1qHvypeJ//dx7gfZrCMP8tuFXEPCR5S/LbkOnMgQgKpHuLenbOoVg==";
